export default "__VITE_ASSET__DqXKds1d__"